import SideBar from ".";
import NavBar from "../NavBar";

function SideBarPage(props: { children: React.ReactNode }) {
  return <div className="flex flex-col bg-background">
    <NavBar />
    <div className="flex h-full flex-1 flex-row bg-background pt-12">
      <SideBar />
      <div className="min-h-[calc(100vh_-_3rem)] w-full flex-1 bg-background px-4 pt-4 min-w-0">
        {props.children}
      </div>
    </div>
  </div>
}

export default SideBarPage;
